module.exports = __webpack_public_path__ + "img/西瓜9.98f8da56.png";